module.exports = __webpack_public_path__ + "static/media/13_genderless.30f75142.jpg";